import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { RequestSubCategoryType, RequestCategoryType } from 'src/app/request-v2/models/request.model';
import { RequestsV2ImplService } from 'src/app/request-v2/services/requests-v2.impl.service';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
    selector: 'app-subject-select',
    templateUrl: './subject-select.component.html',
    styleUrls: ['./subject-select.component.scss'],
})
export class SubjectSelectComponent implements OnChanges {
    @Input() subjects: RequestSubCategoryType[] = [];
    @Input() selectedSubject: RequestSubCategoryType | null = null;
    @Input() requestId: string;
    @Input() readOnly: boolean = false;
    @Input() variant: 'card' | 'list' = 'card';
    @Input() pendingCategoryChange: boolean = false;
    @Input() parentCategory: RequestCategoryType | null = null;

    // Track original subject when in pending category change mode
    private originalSubject: RequestSubCategoryType | null = null;

    @Output() subjectChange = new EventEmitter<RequestSubCategoryType>();
    @Output() subjectChangeForCategory = new EventEmitter<RequestSubCategoryType>();
    @Output() menuClosed = new EventEmitter<void>();

    @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;

    constructor(private requestsService: RequestsV2ImplService) {}

    ngOnChanges(changes: SimpleChanges): void {
        // If we receive a new parent category, open the subject menu automatically
        if (changes.parentCategory && changes.parentCategory.currentValue && this.pendingCategoryChange && this.menuTrigger) {
            // Store the original subject when entering pending mode
            if (!this.originalSubject) {
                this.originalSubject = this.selectedSubject;
            }

            setTimeout(() => {
                this.openSubjectMenu();
            }, 0);
        }

        // If subjects change due to a category change, reset selected subject
        if (changes.subjects && changes.subjects.currentValue && this.pendingCategoryChange) {
            // Don't reset selectedSubject here since we need to keep track of what the user is selecting
        }

        // When pendingCategoryChange becomes false and we weren't in the middle of a category change
        if (changes.pendingCategoryChange && changes.pendingCategoryChange.previousValue === true && !changes.pendingCategoryChange.currentValue) {
            // Reset our tracking variable
            this.originalSubject = null;
        }
    }

    onSubjectSelect(subjectId: string): void {
        if (this.readOnly) return;

        const foundSubject = this.subjects?.find((s) => s._id === subjectId);
        if (!foundSubject) return;

        // If we're in the middle of a category change, emit through the special event
        if (this.pendingCategoryChange) {
            this.subjectChangeForCategory.emit(foundSubject);
            this.selectedSubject = foundSubject;
        } else {
            // Normal flow - just update the subject
            this.subjectChange.emit(foundSubject);

            if (this.requestId) {
                this.requestsService.updateRequestSubCategory(this.requestId, subjectId).subscribe(
                    (updatedRequest) => {
                        this.selectedSubject = foundSubject;
                    },
                    (error) => {},
                );
            }
        }
    }

    openSubjectMenu(): void {
        if (this.menuTrigger && !this.readOnly) {
            this.menuTrigger.openMenu();

            // Subscribe to the closed event if we're in pending category change mode
            if (this.pendingCategoryChange) {
                this.menuTrigger.menuClosed.subscribe(() => {
                    this.menuClosed.emit();
                });
            }
        }
    }
}
